/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const StartLoginParams = zod.object({
  returnTo: zod.string().optional(),
});

export type StartLoginParams = zod.input<typeof StartLoginParams>;
export type StartLoginParamsOutput = zod.output<typeof StartLoginParams>;
